import { Box, Divider, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import NoDataFound from "../../../components/NodataIndication/NoDataFound";
import { ChartSkeleton } from "./SkeletonDesigns";
import useResponsive from "../../../Hooks/useResponsive";

const RightSection = ({ data, loading }) => {
   const mdUp = useResponsive("up", "md");
  const goals = Array.isArray(data?.data) ? data.data : [];
  const [state, setState] = useState(null);
  const [Radial, setRadial] = useState(null);
  useEffect(() => {
    if (!loading && goals.length) {
      const goalPercentages = goals.map(
        (goal) => goal?.completedPercentage ?? 0
      );
      const goalLabels = goals.map((_, i) => `G ${i + 1}`);
      const goalNames = goals.map(
        (goal) => goal?.goal_name ?? `Goal ${goal?.goal_id ?? ""}`
      );
      // const overallPercentage = goals.length
      //   ? goals.reduce(
      //       (sum, goal) => sum + (goal?.completedPercentage ?? 0),
      //       0
      //     ) / goals.length
      //   : 0;
      const overallPercentage = goals.length
        ? Math.round(
            goals.reduce(
              (sum, goal) => sum + (goal?.completedPercentage ?? 0),
              0
            ) / goals.length
          )
        : 0;

      setState({
        series: [
          {
            name: "Goals",
            data: goalPercentages,
          },
        ],
        options: {
          chart: {
            height: 300,
            type: "bar",
            zoom: { enabled: true },
            toolbar: { show: false },
          },
          dataLabels: { enabled: false },
          xaxis: {
            type: "category",
            categories: goalLabels,
          },
          yaxis: {
            min: 10,
            max: 100,
            tickAmount: 9,
          },
          tooltip: {
            x: {
              formatter: (value) => {
                const index = goalLabels.indexOf(value);
                return index !== -1 ? goalNames[index] : value;
              },
            },
          },
        },
      });

      setRadial({
        series: [overallPercentage],
        options: {
          chart: { type: "radialBar", sparkline: { enabled: true } },
          plotOptions: {
            radialBar: {
              startAngle: -90,
              endAngle: 90,
              track: {
                background: "#e7e7e7",
                strokeWidth: "97%",
                margin: 5,
                dropShadow: {
                  enabled: true,
                  top: 2,
                  left: 0,
                  color: "#444",
                  opacity: 1,
                  blur: 2,
                },
              },
              dataLabels: {
                name: { show: false },
                value: {
                  offsetY: 0,
                  fontSize: "24px",
                  fontWeight: "bold",
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              shadeIntensity: 0.4,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 50, 53, 91],
            },
          },
          labels: ["Average Results"],
        },
      });
    }
  }, [data]);

  return (
    <Box>
      <Paper
        elevation={6}
        sx={{
          // maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <Box>
            <ChartSkeleton count={10} />
          </Box>
        ) : goals.length && state && Radial ? (
          <>
            <Box sx={{ height: "300px", p: 1 }}>
              <ReactApexChart
                options={state.options}
                series={state.series}
                type="bar"
                height="100%"
              />
            </Box>
            <Divider sx={{ mt: 1, mb: 3 }} />
            <Box
              sx={{
                height: "150px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <ReactApexChart
                options={Radial.options}
                series={Radial.series}
                type="radialBar"
                height="120%"
              />
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  color: "#333",
                  letterSpacing: "0.5px",
                  position: "relative",
                  top: -70,
                }}
              >
                Overall Goal Progress
              </Typography>
            </Box>
          </>
        ) : (
          // <Box
          //   sx={{
          //     height: "130px",
          //     display: "flex",
          //     flexDirection: "column",
          //     alignItems: "center",
          //     justifyContent: "center",
          //     textAlign: "center",
          //     mt: "20px",
          //   }}
          // >
          //   <ReactApexChart
          //     options={Radial.options}
          //     series={Radial.series}
          //     type="radialBar"
          //     height="120%"
          //   />
          //   <Typography
          //     variant="subtitle1"
          //     sx={{
          //       fontWeight: "bold",
          //       color: "#333",
          //       letterSpacing: "0.5px",
          //       position: "relative",
          //       bottom: 50,
          //     }}
          //   >
          //     Overall Goal Progress
          //   </Typography>
          // </Box>
          !data.data.length && <NoDataFound />
        )}
      </Paper>
    </Box>
  );
};

export default React.memo(RightSection);

// import { Box, Divider, Paper, Typography } from "@mui/material";
// import React, { useState } from "react";
// import ReactApexChart from "react-apexcharts";
// import NoDataFound from "../../../components/NodataIndication/NoDataFound";
// import { ChartSkeleton } from "./SkeletonDesigns";

// const RightSection = ({ data, loading }) => {
//   const goals = Array.isArray(data?.data) ? data.data : [];
//   const goalPercentages = goals.map((goal) => goal?.completedPercentage ?? 0);
//   const goalLabels = goals.map((_, i) => `Goal ${i + 1}`);
//   const goalNames = goals.map(
//     (goal) => goal?.goal_name ?? `Goal ${goal?.goal_id ?? ""}`
//   );
//   const overallPercentage = goals.length
//     ? goals.reduce((sum, goal) => sum + (goal?.completedPercentage ?? 0), 0) /
//       goals.length
//     : 0;

//   const [state, setState] = useState({
//     series: [
//       {
//         name: "Goals",
//         data: goalPercentages,
//       },
//     ],
//     options: {
//       chart: {
//         height: 300,
//         type: "bar",
//         zoom: { enabled: true },
//         toolbar: { show: false },
//       },
//       dataLabels: { enabled: false },
//       xaxis: {
//         type: "category",
//         categories: goalLabels,
//       },
//       yaxis: {
//         min: 10,
//         max: 100,
//         tickAmount: 9, // 10, 20, ..., 100
//       },
//       tooltip: {
//         x: {
//           formatter: (value) => {
//             const index = goalLabels.indexOf(value);
//             return index !== -1 ? goalNames[index] : value;
//           },
//         },
//       },
//     },
//   });
//   const [Radial, setRadial] = React.useState({
//     series: [overallPercentage],
//     options: {
//       chart: {
//         type: "radialBar",
//         // offsetY: -20,
//         sparkline: {
//           enabled: true,
//         },
//       },
//       plotOptions: {
//         radialBar: {
//           startAngle: -90,
//           endAngle: 90,
//           track: {
//             background: "#e7e7e7",
//             strokeWidth: "97%",
//             margin: 5,
//             dropShadow: {
//               enabled: true,
//               top: 2,
//               left: 0,
//               color: "#444",
//               opacity: 1,
//               blur: 2,
//             },
//           },
//           dataLabels: {
//             name: {
//               show: false,
//             },
//             value: {
//               offsetY: 0,
//               fontSize: "24px",
//               fontWeight: "bold",
//             },
//           },
//         },
//       },

//       fill: {
//         type: "gradient",
//         gradient: {
//           shade: "light",
//           shadeIntensity: 0.4,
//           inverseColors: false,
//           opacityFrom: 1,
//           opacityTo: 1,
//           stops: [0, 50, 53, 91],
//         },
//       },
//       labels: ["Average Results"],
//     },
//   });

//   return (
//     <Box>
//       <Paper
//         elevation={6}
//         sx={{
//           // maxHeight: "450px",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         {loading ? (
//           <Box >
//             <ChartSkeleton count={20} />
//           </Box>
//         ) : goals.length ? (
//           <>
//             <Box sx={{ height: "300px", p: 1 }}>
//               <ReactApexChart
//                 options={state.options}
//                 series={state.series}
//                 type="bar"
//                 height="100%"
//               />
//             </Box>
//             <Divider sx={{ mt: 1, mb: 3 }} />
//             <Box
//               sx={{
//                 height: "150px",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 textAlign: "center",
//               }}
//             >
//               <ReactApexChart
//                 options={Radial.options}
//                 series={Radial.series}
//                 type="radialBar"
//                 height="120%"
//               />
//               <Typography
//                 variant="subtitle1"
//                 sx={{
//                   fontWeight: "bold",
//                   color: "#333",
//                   letterSpacing: "0.5px",
//                   position: "relative",
//                   top: -70,
//                 }}
//               >
//                 Overall Goal Progress
//               </Typography>
//             </Box>
//           </>
//         ) : (
//           <NoDataFound />
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default RightSection;
